module.exports = __webpack_public_path__ + "media/stylesheets/images/logo_mattrz_footer-4e47f00699252eb6ae63c41b1cbfa0a5.svg";